import "./mission.css";
const s3url = process.env.REACT_APP_S3_URL;

const Mission = () => {
  return (
    <div className="spoon-shape-none">
      {/* left content div */}
      <div className="mission-image-div">
        <img
          alt=""
          src={`${s3url}/our-mission-about-page-befisc-website.svg`}
          className="mission-image-size"
        />
      </div>

      {/* right image div */}
      <div className="content-mission-div">
        <span className="mission-vision-1">OUR MISSION</span>
        <span className="mission-vision-2">
          Revolutionising <br className="next-line" />{" "}
          <span className="mission-vision-text-2">
            User Authentication and Verification
          </span>
        </span>
        <span className="mission-vision-3">
          We're dedicated to transforming the way businesses approach user
          authentication, verification, and decision-making. By leveraging
          cutting-edge technology, AI, and ML, we're creating seamless solutions
          that streamline processes, enhance security, and deliver exceptional
          user experiences.
        </span>
      </div>
    </div>
  );
};

export default Mission;
